<template>
  <div>
    <form-section
      :title="$t('ApplicationForm_Row_WebsiteSettingsTitle')"
      :description="$t('ApplicationForm_Row_WebsiteSettingsInfo')"
    >
      <el-row>
        <el-col :span="12">
          <rest-form-item
            prop="web_title"
            :label="$t('ApplicationForm_Field_WebsiteName')"
          >
            <el-input v-model="model.web_title" />
          </rest-form-item>
        </el-col>

        <el-col :span="12">
          <rest-form-item
            prop="web_url"
            :label="$t('ApplicationForm_Field_WebsiteURL')"
          >
            <el-input v-model="model.web_url" />
          </rest-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <rest-form-item
            prop="web_domain"
            :label="$t('ApplicationForm_Field_AllowedHTTPOrigins')"
          >
            <el-input type="textarea" v-model="model.web_domain" :rows="6" />
          </rest-form-item>
        </el-col>
        <el-col :span="12">
          <rest-form-item
            prop="ga_tracking_id"
            :label="$t('ApplicationForm_Field_GaTrackingId')"
          >
            <el-input
              v-model="model.ga_tracking_id"
              maxlength="32"
              placeholder="G-XXXXXX"
            />
          </rest-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col class="el-col-" :span="null">
          <rest-form-item
            prop="web_icon_small_file"
            :label="$t('ApplicationForm_Field_SmallIcon')"
          >
            <icon-upload
              :value="model.web_icon_small"
              :file.sync="model.web_icon_small_file"
              accepts=".png"
            />
          </rest-form-item>
        </el-col>
        <el-col class="el-col-" :span="null">
          <rest-form-item
            prop="web_icon_large_file"
            :label="$t('ApplicationForm_Field_LargeIcon')"
          >
            <icon-upload
              :value="model.web_icon_large"
              :file.sync="model.web_icon_large_file"
              accepts=".png"
            />
          </rest-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <rest-form-item
            prop="c"
            :label="$t('ApplicationForm_Field_ClientCookies')"
          >
            <el-switch
              v-model="clientCookies"
              :inactive-value="false"
              :active-value="true"
            />
          </rest-form-item>
        </el-col>
      </el-row>

      <el-row class="example-row">
        <el-col :span="12">
          <rest-form-item
            prop="web_push_cookie_domain"
            :label="$t('ApplicationForm_Field_CookieDomain')"
          >
            <el-input v-model="model.webpush_cookie_domain" />
          </rest-form-item>
        </el-col>

        <el-col :span="12">
          <p class="info-text">
            {{ $t('ApplicationForm_Row_WebsiteSettingsPrefixDomain') }}
            <strong>
              {{ $t('ApplicationForm_Row_WebsiteSettingsExample') }}
            </strong>
          </p>
        </el-col>
      </el-row>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import { WindowTypes } from '@/modules/account/enum/WindowTypes'
import IconUpload from '@/common/components/form/IconUpload'

export default {
  name: 'ApplicationWebFormPage',

  components: {
    RestFormItem,
    FormSection,
    IconUpload
  },

  props: {
    model: {
      required: true,
      type: Object
    },
    files: {
      required: true,
      type: Object
    },
    readonly: {
      required: true,
      type: Boolean
    }
  },

  data() {
    return {
      /*
       * Do not ask why this is here... It exists to satisfy a UX design in
       * which a switches state is dependant upon the text box below it
       * (webpush_cooke_domain) corresponding field in the model having data
       */
      clientCookies: !!this.model.webpush_cookie_domain,
      WindowTypes
    }
  }
}
</script>

<style scoped>
.example-row {
  display: flex;
  align-items: center;
}

.display-flex {
  display: flex;
}

.margin-right {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/account/components/ApplicationWebFormPage.vue